import React from 'react';
import HeroSection from './HeroSection.js';
import ServicesSection from './ServicesSection.js';
import Testimonials from './Testimonials.js';
import FAQ from './FAQ.js';
import Services from './Services.js';
import './HomePage.css';
import PricingPackages from './PricingPackages.js';
import DesignProcess from './DesignProcess.js';
import useScrollToTop from './useScrollToTop';
import WhyChooseUs from './WhyChooseUs.js';
import GetQuoteForm from './GetQuoteForm.js';
import ProjectGallery from './ProjectGallery';

import kitchenimg5 from '../img/kitchen_img_5.jpeg';
import kitchenimg6 from '../img/kitchen_img_6.jpeg';
import kitchenimg8 from '../img/kitchen_img_8.jpg';
import hallimg from '../img/hall_img_1.jpg';
import livingroomimg1 from '../img/living_room_img_1.jpg';
import livingroomimg2 from '../img/living_room_img_2.jpg';
import livingroomimg3 from '../img/living_room_img_3.jpg';
import bedroomimg1 from '../img/room_img_1.jpg';
import bedroomimg2 from '../img/room_img_2.jpg';
import bedroomimg3 from '../img/room_img_3.jpg';
import AboutUs from './AboutUs.js';
import Seo from './Seo';
import homefaqData from './homefaqData.js'
import HomePageLanding from './HomePageLanding.js';


const HomePage = () => {

  useScrollToTop();
  const projectImages = [kitchenimg5,kitchenimg6,kitchenimg8,hallimg,
    livingroomimg1,livingroomimg2,livingroomimg3,bedroomimg1,bedroomimg2,bedroomimg3,

  ];
    return (
      <div className="home-page">
        <Seo
        title="Construction Consultancy | Project Management & Design"
        description="Expert construction consultancy services. We provide project management, design, and supervision for residential & commercial projects. Contact Housekaar today."
        keywords="construction consultancy, project management, building design, construction supervision, residential construction, commercial construction, Patna, Bihar"
        location="Patna" // Or your relevant location
        imageUrl="https://housekaar.ryanpullover21.workers.dev/static/media/dream_home.17aa0cc793fede9fc07f.jpg" // Adjust the path to your image
      />
      <HomePageLanding/>
        <HeroSection />
        <div>
      <h1 className='panorama-title'> Experience Our Interior Spaces</h1>
      <iframe title="Panorama" width="100%" height="640" frameborder="0" allow="xr-spatial-tracking; gyroscope; accelerometer" allowfullscreen scrolling="no" src="https://kuula.co/share/hJfkT?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1"></iframe>
    </div>
        <AboutUs/>
        <ServicesSection />
        <Services />
        <WhyChooseUs/>
        <DesignProcess/>
        <ProjectGallery images={projectImages} />
        <PricingPackages/>
        <GetQuoteForm/>
        <Testimonials />
        <FAQ faqData ={homefaqData} />
      </div>
    );
  };
  
  export default HomePage;